import type { TranslationKey } from './en'

// Peru-specific Spanish overrides (keep this file tiny).
export const esPE: Partial<Record<TranslationKey, string>> = {
  // Example override slot. Add keys only when Peru wording should differ.
  // 'nav.warehouse': 'Almacén'
}
